import { render } from "./Deliverable.vue?vue&type=template&id=45257cd1&scoped=true&ts=true"
import script from "./Deliverable.vue?vue&type=script&lang=ts"
export * from "./Deliverable.vue?vue&type=script&lang=ts"

import "./Deliverable.vue?vue&type=style&index=0&id=45257cd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45257cd1"]])

export default __exports__